import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const categoryIds = [
    "a826980c-9064-4e33-800a-7ace75e182ae", // prod
    "dcdfc2c5-eaf6-458b-944c-5d4ad61a7a31" // acc
];

export const AudioEnTelefonieFilter = ({ condensed }) => {
    const filter = useFilter("opties").find((category) =>
        categoryIds.includes(category.optiecategorieId)
    );
    const count = useCount("zoekopties");
    const [value, , onChange] = useField("zoekoptieIds");

    const options =
        filter?.zoekopties?.map(({ zoekoptieId, naam }) => ({
            id: zoekoptieId,
            displayName: naam,
            aantal: count[zoekoptieId]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-audio"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 3}
                datalayerKey="zoekoptieId"
                maxSize={0}
            />
        </Grid>
    );
};
